import React from 'react';

const Button = ({ children, variant='primary', size='md', ...rest }) => {
  const cls = ['btn', variant, size === 'sm' ? 'btn-sm' : ''].join(' ');
  return <button className={cls} {...rest}>{children}</button>;
};
export default Button;
